<div @fade>
    <router-outlet></router-outlet>
</div>